import PaginationLink from 'reactstrap/lib/PaginationLink';
export default PaginationLink;